
type ChangedFunction = (customerId: number) => void;

class CustomerChangeTracker {
    static customerChangeEventFunctions: ChangedFunction[] = [];

    subscribe(customerChangeEvent: ChangedFunction) {
        CustomerChangeTracker.customerChangeEventFunctions.push(customerChangeEvent);
    }

    trigger(customerId: number) {
        const goodEvents : ChangedFunction[] = [];

        for (let i = 0; i < CustomerChangeTracker.customerChangeEventFunctions.length; i++) {
            try {
                CustomerChangeTracker.customerChangeEventFunctions[i](customerId);
                goodEvents.push(CustomerChangeTracker.customerChangeEventFunctions[i]);
            } catch (ex) {
                console.log("CustomerChangeTracker.trigger exception: " + ex);
            }
        }

        while(CustomerChangeTracker.customerChangeEventFunctions.length > 0) {
            CustomerChangeTracker.customerChangeEventFunctions.pop();
        }        
        goodEvents.map(e => {CustomerChangeTracker.customerChangeEventFunctions.push(e); return null;});         
    }
}

export default new CustomerChangeTracker();